<template>
  <div class="detail_panel_mask" v-if="visible" @click.self="close">
    <div class="detail_panel" :class="{ panel_enter: animEnter }">
      <div class="panel_header">
        <div class="panel_close" @click="close">&times;</div>
      </div>
      <div class="panel_body">
        <div class="current_digest">
          <div class="digest_title">{{ currentItem.title }}</div>
          <div class="digest_content">{{ currentItem.content }}</div>
          <div class="digest_meta">
            <span v-if="currentItem.bookName" class="meta_book">《{{ currentItem.bookName }}》</span>
            <span v-if="currentItem.bookAuthor" class="meta_author">{{ currentItem.bookAuthor }}</span>
            <span class="meta_date">{{ currentEditDate }}</span>
          </div>
        </div>
        <div class="related_tabs">
          <div
            class="tab_item"
            :class="{ active: activeTab === 'book' }"
            @click="switchTab('book')"
          >同书</div>
          <div
            class="tab_item"
            :class="{ active: activeTab === 'author' }"
            @click="switchTab('author')"
          >同作者</div>
          <div
            class="tab_item"
            :class="{ active: activeTab === 'date' }"
            @click="switchTab('date')"
          >同日</div>
        </div>
        <div class="related_list">
          <div v-if="loading" class="loading_tip">加载中...</div>
          <div v-else-if="relatedList.length === 0" class="empty_tip">暂无相关书摘</div>
          <div
            v-else
            class="related_item"
            v-for="(item, index) in relatedList"
            :key="index"
            @click="jumpTo(item)"
          >
            <div class="related_content">{{ item.content }}</div>
            <div class="related_meta">
              <span v-if="item.bookName" class="meta_book">《{{ item.bookName }}》</span>
              <span v-if="item.bookAuthor" class="meta_author">{{ item.bookAuthor }}</span>
              <span class="meta_date">{{ item.editTime ? item.editTime.split(' ')[0] : '' }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { sameBookDigest, sameAuthorDigest, sameDateDigest } from '@/vue_api/bookNotes.js'

export default {
  name: 'detailPanel',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      activeTab: 'book',
      relatedList: [],
      loading: false,
      animEnter: false,
      currentItem: {}
    }
  },
  computed: {
    currentEditDate() {
      return this.currentItem.editTime ? this.currentItem.editTime.split(' ')[0] : ''
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.currentItem = { ...this.item }
        this.activeTab = 'book'
        this.$nextTick(() => {
          this.animEnter = true
        })
        this.fetchRelated()
      } else {
        this.animEnter = false
      }
    }
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
    },
    switchTab(tab) {
      this.activeTab = tab
      this.fetchRelated()
    },
    async fetchRelated() {
      this.loading = true
      this.relatedList = []
      try {
        let res
        if (this.activeTab === 'book') {
          res = await sameBookDigest({ bookName: this.currentItem.bookName || '' })
        } else if (this.activeTab === 'author') {
          res = await sameAuthorDigest({ bookAuthor: this.currentItem.bookAuthor || '' })
        } else {
          const editDate = this.currentItem.editTime ? this.currentItem.editTime.split(' ')[0] : ''
          res = await sameDateDigest({ editDate })
        }
        this.relatedList = res && res.data && res.data.status ? res.data.digestList : []
      } catch (e) {
        this.relatedList = []
      }
      this.loading = false
    },
    jumpTo(item) {
      this.currentItem = { ...item }
      this.fetchRelated()
    }
  }
}
</script>

<style lang="scss" scoped>
.detail_panel_mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.45);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.detail_panel {
  width: 7rem;
  max-width: 90vw;
  max-height: 80vh;
  background: #fff;
  border-radius: .12rem;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transform: translateY(30px);
  opacity: 0;
  transition: transform 0.35s ease, opacity 0.35s ease;

  &.panel_enter {
    transform: translateY(0);
    opacity: 1;
  }
}

.panel_header {
  display: flex;
  justify-content: flex-end;
  padding: .1rem .15rem;

  .panel_close {
    width: .3rem;
    height: .3rem;
    line-height: .3rem;
    text-align: center;
    font-size: .24rem;
    color: #999;
    cursor: pointer;
    border-radius: 50%;
    transition: background 0.2s;

    &:hover {
      background: #f0f0f0;
      color: #333;
    }
  }
}

.panel_body {
  flex: 1;
  overflow-y: auto;
  padding: 0 .25rem .2rem;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 3px;
    background: rgba(0, 0, 0, 0.15);
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }
}

.current_digest {
  padding-bottom: .2rem;
  border-bottom: 1px solid #eee;

  .digest_title {
    font-size: .22rem;
    font-weight: 600;
    color: #333;
    margin-bottom: .12rem;
  }

  .digest_content {
    font-size: .16rem;
    line-height: 1.8;
    color: #444;
    white-space: pre-wrap;
    word-break: break-all;
    margin-bottom: .12rem;
  }

  .digest_meta {
    font-size: .13rem;
    color: #999;
    display: flex;
    align-items: center;
    gap: .1rem;

    .meta_book {
      color: #666;
      font-weight: 500;
    }
  }
}

.related_tabs {
  display: flex;
  margin: .15rem 0;
  border-bottom: 2px solid #f0f0f0;

  .tab_item {
    padding: .08rem .2rem;
    font-size: .15rem;
    color: #999;
    cursor: pointer;
    border-bottom: 2px solid transparent;
    margin-bottom: -2px;
    transition: color 0.2s, border-color 0.2s;

    &:hover {
      color: #666;
    }

    &.active {
      color: rgba(102, 153, 204, 1);
      border-bottom-color: rgba(102, 153, 204, 1);
      font-weight: 500;
    }
  }
}

.related_list {
  .loading_tip,
  .empty_tip {
    text-align: center;
    color: #bbb;
    padding: .3rem 0;
    font-size: .14rem;
  }
}

.related_item {
  padding: .12rem;
  margin-bottom: .1rem;
  background: rgba(245, 245, 245, 0.8);
  border-radius: .06rem;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: rgba(230, 240, 255, 0.8);
  }

  .related_content {
    font-size: .14rem;
    line-height: 1.7;
    color: #444;
    white-space: pre-wrap;
    word-break: break-all;
    margin-bottom: .06rem;
  }

  .related_meta {
    font-size: .12rem;
    color: #999;
    display: flex;
    align-items: center;
    gap: .08rem;

    .meta_book {
      color: #666;
    }
  }
}

@media screen and (max-width: 500px) {
  .detail_panel {
    width: 95vw;
    max-height: 85vh;
    border-radius: .08rem;
  }

  .panel_body {
    padding: 0 .15rem .15rem;
  }

  .current_digest {
    .digest_title {
      font-size: .18rem;
    }

    .digest_content {
      font-size: .14rem;
    }
  }

  .related_tabs .tab_item {
    font-size: .14rem;
    padding: .06rem .15rem;
  }
}
</style>